/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { invalidateAuditLogQueries } from "../../utils/invalidateAuditLogQueries";
import React, { useState, useEffect, useContext, useRef } from "react";
import { NavigableBreadcrumbLink } from "../../components/page_breadcrumbs/navigable_breadcrumb_link";
import { configuredDiscountMutationKeyGroups } from "../../hooks/mutations/queryKeyGroups/configuredDiscountMutationKeys";
import { useOtMutation } from "../../hooks/mutations/useOtMutation";
import {
  Breadcrumbs,
  Box,
  Typography,
  Select,
  IconButton,
  Alert,
  Button,
  Switch,
  Popover,
  InputAdornment,
} from "@mui/material";
import {
  ConfiguredDiscountPage,
  filterContinerStyle,
  filterSectionStyle,
  typographyStyle,
  menuPropStyle,
  actionSectionStyle,
  FetchButtonContainer,
  StatusContainer,
  statusMenuPropStyle,
  ClassificationActionButton,
  StyledStatusButton,
  StatusMenuList,
  statusPopoverPaperStyle,
  statusMenuItemStyle,
} from "./styles";
import {
  StyledBreadCrumbContainer,
  StyledLink,
  StyledInputLabel,
} from "../reports/employee_visibility/styles";
import { FilterContainer } from "../../components/filter_container";
import {selectBaseStyles } from "../reports/styles";
import DropdownSearchBar from "../../components/dorpdown_searchbar";
import { DropdownInfiniteLoader } from "../../components/dropdown_infinite_loader";
import { SelectedMenuItem } from "../../components/selected_menu_item";
import { StyledMenuItem } from "../../components/styled_menu_item";
import { useInfiniteQuery, useQuery, keepPreviousData, useQueryClient } from "@tanstack/react-query";
import api from "../../api";
import authenticatedFetch from "../../api/authenticatedFetch";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { StyledSearchBar } from "../reports/global_employee_search/styles";
import { ResetButton } from "../../components/reset_button";
import { StyledFilterCancel, StyledFormControl } from "../dashboard/styles";
import { startCase, capitalize } from 'lodash'
import { UpdateButton } from "../../components/update_button";
import { hasSingleItem } from "../../utils/hasSingleItem";
import { getSingleItemValue } from "../../utils/getSingleItemValue";
import camelize from "../../utils/camelize";
import { Loader } from "../../components/loader";
import { IndexTable } from "../../components/index_table";
import { useNotificationContext } from "../../contexts/notificationContext";
import { formatDate } from "../../utils/formatDate";
import { LoadingSpinner } from "../../components/loading_spinner";
import CachedIcon from "@mui/icons-material/Cached";
import { MenuHeading } from "../../components/menu_heading";
import { AbilityContext } from "../../contexts/abilityContext";
import { strictCanScope } from "../../utils/caslStrict";
import { checkAdmin } from "../../utils/checkAdmin";
import { useSelector } from "react-redux";
import { Query_Keys } from "../../lib/queryKeys";
import { DiscountClassificationModal } from "../../components/discount_classification_modal";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useLocation } from "react-router-dom";
import { buildQueryParams } from "../../utils/buildQueryParams";
import { PerPage } from "../../constants/perPage";
import {
  getDropdownNextPageParam,
  mergeUniqueByKey,
  normalizeRestaurant,
  normalizeRestaurantGroup
} from "../../utils/dropdownInfiniteQuery";
import { useDebounce } from "../../utils/useDebounce";
import { useInfiniteScrollObserver } from "../../hooks/useInfiniteScrollObserver";
import dayjs from "dayjs";

const EMPTY_FILTERS = {
  restaurant_group_id: '',
  restaurant_ids: [],
  status: '',
}

export const ConfiguredDiscount = () => {
  const location = useLocation()
  const navigatedRestaurant = location?.state?.restaurant
  const navigatedRestaurantId = typeof navigatedRestaurant === 'object' ? navigatedRestaurant?.id : null
  const navigatedRestaurantName = typeof navigatedRestaurant === 'object' ? navigatedRestaurant?.name : navigatedRestaurant || ''
  const singleRestaurantGroupAutoApplied = useRef(false)
  const singleRestaurantAutoApplied = useRef(false)
  const initialFilters = {
    restaurant_group_id: location?.state?.restaurantGroupId || '',
    restaurant_ids: location?.state?.restaurantIds || [],
    status: location?.state?.status || '',
  }
  const [filters, setFilters] = useState(initialFilters)
  const [appliedFilters, setAppliedFilters] = useState(initialFilters)
  const [filtersChanged, setFiltersChanged] = useState(false)
  const [restaurantGroupSearch, setRestaurantGroupSearch] = useState('')
  const [restaurantSearch, setRestaurantSearch] = useState('')
  const [search, setSearch] = useState('')
  const [prefillRestaurantName, setPrefillRestaurantName] = useState(navigatedRestaurantName)
  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(25)
  const [isLoading, setIsLoading] = useState(false)
  const [fetchPermission, setFetchPermission] = useState(false)
  const [selectedIds, setSelectedIds] = useState([])
  const [open, setOpen] = useState(false)
  const [statusLoading, setStatusLoading] = useState(false)
  const [rowStatusLoadingId, setRowStatusLoadingId] = useState(null)
  const [statusMenuAnchorEl, setStatusMenuAnchorEl] = useState(null)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [selectedAction, setSelectedAction] = useState('')
  const [statusUpdatePermission, setStatusUpdatePermission] = useState(false)
  const [appliedStatusUpdatePermission, setAppliedStatusUpdatePermission] = useState(false)
  const [csvLoading, setCsvLoading] = useState(false)
  const [sortBy, setSortBy] = useState('created_at')
  const [sortOrder, setSortOrder] = useState('desc')
  const [restaurantGroupOptionsCache, setRestaurantGroupOptionsCache] = useState([])
  const [restaurantOptionsCache, setRestaurantOptionsCache] = useState([])
  const { admin } = useSelector((state) => state.admin);
  const superAdmin = checkAdmin(admin?.formatted_roles)
  const showNotification = useNotificationContext();
  const { ability } = useContext(AbilityContext);
  const queryClient = useQueryClient();
  const debouncedRestaurantGroupSearch = useDebounce(restaurantGroupSearch.trim(), 300)
  const debouncedRestaurantSearch = useDebounce(restaurantSearch.trim(), 300)
  const debouncedSearchTerm = useDebounce(search.trim(), 300)
  const STATUS = [
    {
      label: 'Managed',
      value: 'managed'
    },
    {
      label: 'Unmanaged',
      value: 'unmanaged',
    },
    {
      label: 'Unclassified',
      value: 'unclassified',
    }
  ]

  const actions = [
    {
      label: 'Managed',
      value: 'managed',
    },
    {
      label: 'Unmanaged',
      value: 'unmanaged',
    },
  ]

  const STATUS_ERRORS = {
    invalid_status: 'Please select correct classification status',
    restaurant_error: 'Restaurant not found',
    configured_discount_error: 'Configured discount not found',
    restaurant_group_error: 'Restaurant group not found',
  }
  const rowStatusOptions = actions

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

  const fetchRestaurantGroupList = async ({ pageParam = 1 }) => {
    const response = await api.get("/v1/admin/dropdowns/restaurant_groups_list", {
      params: {
        page: pageParam,
        per_page: PerPage,
        search: debouncedRestaurantGroupSearch || undefined,
      },
    });
    return response?.data?.map(normalizeRestaurantGroup) || [];
  };

  const {
    data: restaurantGroups = [],
    isFetching: restaurantGroupFetching,
    isFetchingNextPage: restaurantGroupsFetchingNextPage,
    fetchNextPage: fetchNextRestaurantGroupsPage,
    hasNextPage: hasNextRestaurantGroupsPage,
  } = useInfiniteQuery({
    queryKey: Query_Keys.restaurant_groups_dropdown({ search: debouncedRestaurantGroupSearch }),
    queryFn: fetchRestaurantGroupList,
    initialPageParam: 1,
    getNextPageParam: getDropdownNextPageParam,
    select: (data) => data.pages.flat(),
    staleTime: 10 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

  const fetchRestaurants = async ({ pageParam = 1 }) => {
    let res = await api.get("/v1/admin/dropdowns/restaurants_list", {
      params: {
        restaurant_group_ids: filters?.restaurant_group_id,
        page: pageParam,
        per_page: PerPage,
        search: debouncedRestaurantSearch || undefined,
      }
    });
    return res?.data?.map(normalizeRestaurant) || [];
  };

  const {
    data: restaurants = [],
    isFetching: restaurantFetching,
    isFetchingNextPage: restaurantsFetchingNextPage,
    fetchNextPage: fetchNextRestaurantsPage,
    hasNextPage: hasNextRestaurantsPage,
  } = useInfiniteQuery({
    queryKey: Query_Keys.restaurants_dropdown({
      restaurant_group_id: filters?.restaurant_group_id,
      search: debouncedRestaurantSearch,
    }),
    queryFn: fetchRestaurants,
    initialPageParam: 1,
    getNextPageParam: getDropdownNextPageParam,
    select: (data) => data.pages.flat(),
    staleTime: 10 * 60 * 1000,
    placeholderData: keepPreviousData,
  });

  const { rootRef: restaurantGroupMenuRef, targetRef: restaurantGroupLoaderRef } = useInfiniteScrollObserver({
    fetchNextPage: fetchNextRestaurantGroupsPage,
    hasNextPage: hasNextRestaurantGroupsPage,
    isFetchingNextPage: restaurantGroupsFetchingNextPage,
  })

  const { rootRef: restaurantMenuRef, targetRef: restaurantLoaderRef } = useInfiniteScrollObserver({
    fetchNextPage: fetchNextRestaurantsPage,
    hasNextPage: hasNextRestaurantsPage,
    isFetchingNextPage: restaurantsFetchingNextPage,
  })

  const fetchConfiguredDiscounts = async () => {
    const res = await api.get('/v1/admin/configured_discounts', { params: {
      restaurant_group_id: appliedFilters?.restaurant_group_id,
      restaurant_ids: appliedFilters?.restaurant_ids,
      status: appliedFilters?.status,
      search: debouncedSearchTerm || undefined,
      sort_by: sortBy,
      sort_order: sortOrder,
      page: page,
      per_page: itemsPerPage,
    }})

    return { data: res?.data, pageCount: res?.headers["total-count"] }
  }

  const hasAppliedSelection = Boolean(appliedFilters?.restaurant_group_id || appliedFilters?.restaurant_ids?.length > 0)

  const { data: configuredDiscounts, isFetching } = useQuery({
    queryKey: Query_Keys.configured_discounts({
      queryFilter: appliedFilters,
      page: page,
      itemsPerPage: itemsPerPage,
      search: debouncedSearchTerm,
      sortBy,
      sortOrder,
    }),
    queryFn: fetchConfiguredDiscounts,
    staleTime: 10 * 60 * 1000,
    enabled: hasAppliedSelection,
    placeholderData: keepPreviousData,
  })

  useEffect(() => {
    setRestaurantGroupOptionsCache((currentOptions) => mergeUniqueByKey(currentOptions, restaurantGroups, 'label'))
  }, [restaurantGroups])

  useEffect(() => {
    setRestaurantOptionsCache((currentOptions) => mergeUniqueByKey(currentOptions, restaurants, 'id'))
  }, [restaurants])

  const hasSingleAvailableRestaurantGroup = !debouncedRestaurantGroupSearch && hasSingleItem(restaurantGroups)
  const hasSingleAvailableRestaurant = !debouncedRestaurantSearch && hasSingleItem(restaurants)

  useEffect(() => {
    if (!navigatedRestaurantId && !navigatedRestaurantName) {
      return
    }

    const filter = {
      restaurant_group_id: null,
      restaurant_ids: navigatedRestaurantId ? [navigatedRestaurantId] : [],
      status: '',
    }

    setFilters(filter)
    setPrefillRestaurantName(navigatedRestaurantName)

    if (navigatedRestaurantName) {
      setRestaurantSearch(navigatedRestaurantName)
    }

    if (navigatedRestaurantId) {
      applySelectedFilters(filter)
    }
  }, [navigatedRestaurantId, navigatedRestaurantName])

  useEffect(() => {
    if (!prefillRestaurantName) {
      return
    }

    const matchedRestaurant = restaurantOptionsCache?.find((restaurant) => (
      String(restaurant?.id) === String(navigatedRestaurantId) || restaurant?.name === prefillRestaurantName
    ))

    if (!matchedRestaurant) {
      return
    }

    const filter = {
      restaurant_group_id: null,
      restaurant_ids: [matchedRestaurant.id],
      status: '',
    }

    setFilters(filter)
    checkFetchPermission(filter.restaurant_ids)
    checkUpdateStatusPermission(filter.restaurant_ids)
    applySelectedFilters(filter)

    if (restaurantSearch === prefillRestaurantName) {
      setRestaurantSearch('')
    }

    setPrefillRestaurantName('')
  }, [navigatedRestaurantId, prefillRestaurantName, restaurantOptionsCache, restaurantSearch])

  useEffect(() => {
    if ((navigatedRestaurantId || navigatedRestaurantName) || singleRestaurantGroupAutoApplied.current || !hasSingleAvailableRestaurantGroup) {
      return
    }

    const singleRestaurantGroup = getSingleItemValue(restaurantGroups)
    const nextFilters = {
      ...EMPTY_FILTERS,
      restaurant_group_id: singleRestaurantGroup?.label,
      restaurant_ids: [],
    }

    singleRestaurantGroupAutoApplied.current = true
    setFilters(nextFilters)
    applySelectedFilters(nextFilters)
  }, [hasSingleAvailableRestaurantGroup, navigatedRestaurantId, navigatedRestaurantName, restaurantGroups])

  useEffect(() => {
    if ((navigatedRestaurantId || navigatedRestaurantName) || singleRestaurantAutoApplied.current || !hasSingleAvailableRestaurant) {
      return
    }

    if (hasSingleAvailableRestaurantGroup && !filters?.restaurant_group_id) {
      return
    }

    const singleRestaurant = getSingleItemValue(restaurants)
    const nextFilters = {
      ...EMPTY_FILTERS,
      restaurant_group_id: hasSingleAvailableRestaurantGroup
        ? getSingleItemValue(restaurantGroups)?.label
        : filters?.restaurant_group_id, restaurant_ids: [singleRestaurant.id]
    }

    singleRestaurantAutoApplied.current = true
    setFilters(nextFilters)
    applySelectedFilters(nextFilters)
    setFetchPermission(strictCanScope(ability, 'fetch_and_imports', 'Restaurant', `${singleRestaurant.id}`))
    setStatusUpdatePermission(strictCanScope(ability, 'update', 'Restaurant', `${singleRestaurant.id}`))
  }, [ability, filters?.restaurant_group_id, hasSingleAvailableRestaurant, hasSingleAvailableRestaurantGroup, navigatedRestaurantId, navigatedRestaurantName, restaurantGroups, restaurants])

  useEffect(() => {
    if (filters?.restaurant_ids?.length > 0) {
      checkUpdateStatusPermission(filters.restaurant_ids)
      return
    }

    if (filters?.restaurant_group_id) {
      if (superAdmin?.role === 'admin') {
        setStatusUpdatePermission(true)
        return
      }

      const hasGroupPermission = restaurantOptionsCache?.some((restaurant) => (
        strictCanScope(ability, 'update', 'Restaurant', `${restaurant?.id}`)
      ))

      setStatusUpdatePermission(Boolean(hasGroupPermission))
      return
    }

    setStatusUpdatePermission(false)
  }, [ability, filters?.restaurant_group_id, filters?.restaurant_ids, restaurantOptionsCache, superAdmin?.role])

  useEffect(() => {
    const hasAppliedSelection = Boolean(appliedFilters?.restaurant_group_id || appliedFilters?.restaurant_ids?.length > 0)

    if (!hasAppliedSelection || filtersChanged) return

    setAppliedStatusUpdatePermission(statusUpdatePermission)
  }, [appliedFilters, filtersChanged, statusUpdatePermission])

  const handleRestaurantGroupChange = (event) => {
    setFilters(prev => ({...prev, restaurant_group_id: event.target.value, restaurant_ids: []}))
    setPrefillRestaurantName('')
    setFiltersChanged(true)
    setFetchPermission(false)
    setStatusUpdatePermission(false)
  }

  const handleRestaurantChange = (event) => {
    setFilters(prev => ({...prev, restaurant_ids: event.target.value}))
    setPrefillRestaurantName('')
    checkFetchPermission(event.target.value)
    checkUpdateStatusPermission(event.target.value)
    setFiltersChanged(true)
  }

  const handleStatusChange = (event) => {
    setFilters(prev => ({...prev, status: event.target.value}))
    setFiltersChanged(true)
  }

  const handleRestaurantGroupClear = () => {
    setFilters(prev => ({...prev, restaurant_group_id: null, restaurant_ids: []}))
    setPrefillRestaurantName('')
    setFiltersChanged(true)
    setFetchPermission(false)
    setStatusUpdatePermission(false)
  }

  const handleRestaurantClear = () => {
    setFilters(prev => ({...prev, restaurant_ids: []}))
    setPrefillRestaurantName('')
    setFiltersChanged(true)
    setFetchPermission(false)
  }

  const handleStatusClear = () => {
    setFilters(prev => ({...prev, status: ''}))
    setFiltersChanged(true)
  }

  const checkFetchPermission = (fetchRestaurants) => {
    let fetchRestaurantsList = []

    if (superAdmin?.role === 'admin') {
      setFetchPermission(true)
      return
    }

    fetchRestaurants?.forEach((id) => {
      restaurantOptionsCache?.forEach((restaurant) => {
        if (restaurant?.id === id) {
          fetchRestaurantsList.push(restaurant)
        }
      })
    })

    if (fetchRestaurantsList.length === 0) {
      setFetchPermission(false)
      return
    }

    for (const restaurant of fetchRestaurantsList) {
      if (strictCanScope(ability, 'fetch_and_imports', 'Restaurant', `${restaurant?.id}`)) {
        setFetchPermission(true)
        return
      }
      setFetchPermission(false)
    }
  }

  const checkUpdateStatusPermission = (updateRestaurants) => {
    let updateRestaurantList = []

    if (superAdmin?.role === 'admin') {
      setStatusUpdatePermission(true)
      return
    }

    updateRestaurants?.forEach((id) => {
      restaurantOptionsCache?.forEach((restaurant) => {
        if (restaurant?.id === id) {
          updateRestaurantList.push(restaurant)
        }
      })
    })

    if (updateRestaurantList.length === 0) {
      setStatusUpdatePermission(false)
      return
    }

    for (const restaurant of updateRestaurantList) {
      if (strictCanScope(ability, 'update', 'Restaurant', `${restaurant?.id}`)) {
        setStatusUpdatePermission(true)
        return
      }
      setStatusUpdatePermission(false)
    }
  }

  const getRestaurantGroupName = (id) => {
    const restaurantGroup = restaurantGroupOptionsCache?.find((res) => res.label === Number(id) || res.label === id)
    return restaurantGroup ? restaurantGroup?.value : ''
  }

  const getRestaurantDisplayValue = () => {
    if(filters?.restaurant_ids.length === 0) return prefillRestaurantName || undefined

    if (filters?.restaurant_ids?.length === 1) {
      const restaurant = restaurantOptionsCache.find(r => r.id === filters.restaurant_ids[0]);
      return restaurant ? restaurant.name : prefillRestaurantName || 'Restaurant selected';
    }

    return `${filters?.restaurant_ids?.length} Restaurants Selected`;
  }

  const getAmount = (amount, type) => {
    if(!amount) return 'N/A'

    const normalizedAmount = Number(amount).toFixed(2)
    switch(type) {
      case 'Fixed $ off':
        return `$${normalizedAmount}`
      case 'Fixed % off':
        return `${normalizedAmount}%`
      default:
        return normalizedAmount
    }
  }

  const getAdminName = (admin) => {
    if (!admin) return '-'

    return `${admin?.first_name} ${admin?.last_name}`
  }

  const applySelectedFilters = (nextFilters) => {
    setAppliedFilters(nextFilters)
    setFiltersChanged(false)
    setSearch('')
    setItemsPerPage(25)
    setPage(1)
    setSelectedIds([])
  }

  const handleReset = () => {
    setFiltersChanged(false);
    setRestaurantGroupSearch('');
    setRestaurantSearch('');
    setSearch('');
    setPrefillRestaurantName('');
    setStatusMenuAnchorEl(null);
    setSelectedRecord(null);
    setSelectedAction('');
    setStatusLoading(false);
    setRowStatusLoadingId(null);
    setCsvLoading(false);
    setOpen(false);
    setFilters(EMPTY_FILTERS);
    setAppliedFilters(EMPTY_FILTERS);
    setSortBy('created_at');
    setSortOrder('desc');
    setItemsPerPage(25);
    setPage(1);
    setSelectedIds([]);
    setFetchPermission(false);
    setStatusUpdatePermission(false);
    setAppliedStatusUpdatePermission(false);
  }

  const handleChange = () => {
    if(!filters?.restaurant_group_id && filters?.restaurant_ids?.length === 0) {
      showNotification('Please select a restaurant group or restaurant', 'error')
      return
    }
    applySelectedFilters(filters)
  }

  const { mutateAsync: fetchConfiguredDiscountsMutation } = useOtMutation({
    mutationFn: async (id) => await api.post('/v1/admin/configured_discounts/manual_fetch_configured_discount', { restaurant_id: id }),
    invalidateKeys: configuredDiscountMutationKeyGroups.update,
    successMessage: ({ variables: id }) => `Configured discounts fetched successfully for ${getRestaurantName(id)}`,
    errorMessage: ({ variables: id }) => `Failed to fetch configured discounts for ${getRestaurantName(id)}`,
    onSettled: () => {
      invalidateAuditLogQueries(queryClient);
    }
  });

  const fetchDiscountsFromToast = async () => {
    const restaurantIds = filters?.restaurant_ids

    if(restaurantIds?.length === 0) {
      showNotification('Please select at least one restaurant', 'error')
      return
    }

    const fetchConfiguredDiscounts = async (id) => {
      await delay(3500);
      await fetchConfiguredDiscountsMutation(id);
    }

    setIsLoading(true)

    try {
      for (const id of restaurantIds) {
        if (superAdmin?.role === 'admin' || strictCanScope(ability, 'fetch_and_imports', 'Restaurant', `${id}`)) {
          await fetchConfiguredDiscounts(id)
        }
      }
    } catch {
      // Handled in useOtMutation onError
    } finally {
      setIsLoading(false);
    }
  }

  const getRestaurantName = (id) => {
    const restaurantName = restaurantOptionsCache?.find((res) => res.id === id)
    return restaurantName?.name ? restaurantName?.name : prefillRestaurantName
  }

  const filenameFromDisposition = (contentDisposition) => {
    if (!contentDisposition) return null

    const match = contentDisposition.match(/filename="?([^";]+)"?/i)
    return match ? match[1] : null
  }

  const handleExportCsv = async () => {
    if (csvLoading) return

    try {
      setCsvLoading(true)

      const query = buildQueryParams({
        ...appliedFilters,
        search: debouncedSearchTerm || undefined,
        sort_by: sortBy,
        sort_order: sortOrder,
      })

      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/csv_reports/export?report=configured_discounts&${query}`

      const { response } = await authenticatedFetch(url, {
        method: 'GET',
        defaultErrorMessage: 'Failed to export CSV',
      })

      const blob = await response.blob()

      if (!blob || blob.size === 0) {
        showNotification('Failed to export CSV', 'error')
        return
      }

      const downloadUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = downloadUrl

      const fallbackFilename = `configured_discounts_${dayjs().format('YYYY-MM-DD')}.csv`
      a.download = filenameFromDisposition(response.headers.get('content-disposition')) || fallbackFilename
      a.click()

      window.URL.revokeObjectURL(downloadUrl)
      showNotification('CSV exported successfully', 'success')
    } catch (error) {
      console.error('Configured discounts CSV export failed:', error)
      showNotification(error?.message || 'Failed to export CSV', 'error')
    } finally {
      setCsvLoading(false)
    }
  }

  const handleClassificationOpen = () => {
    setOpen(true)
  }

  const handleClassificationClose = () => {
    setOpen(false)
    setSelectedAction('')
  }

  const handleStatusMenuOpen = (event, record) => {
    if (rowStatusLoadingId) return

    setStatusMenuAnchorEl(event.currentTarget)
    setSelectedRecord(record)
  }

  const handleStatusMenuClose = () => {
    if (rowStatusLoadingId) return

    setStatusMenuAnchorEl(null)
    setSelectedRecord(null)
  }

  const clearDashboardCache = () => {
    queryClient.removeQueries({ queryKey: ["dashboard_total_sales"] });
    queryClient.removeQueries({ queryKey: ["dashboard_overview"] });
  }

  const getErrorMessage = (errors = {}) => {
    const errorKey = Object.keys(errors)?.[0]
    return STATUS_ERRORS[errorKey] || 'Failed to update the status'
  }

  const { mutateAsync: bulkStatusUpdateMutation } = useOtMutation({
    mutationFn: async (data) => await api.post('/v1/admin/configured_discounts/bulk_status_update', data),
    invalidateKeys: configuredDiscountMutationKeyGroups.update,
    successMessage: ({ variables }) => {
      if (variables.configured_discount_ids.length > 1 || selectedAction) {
        return superAdmin?.role === 'admin' 
          ? 'Configured perqs updated successfully' 
          : 'Configured perqs updated successfully for permitted restaurants';
      }
      return 'Configured perq updated successfully';
    },
    errorMessage: ({ error }) => getErrorMessage(error?.response?.data?.errors),
    onSuccess: (data, variables) => {
      clearDashboardCache();
      if (variables.configured_discount_ids.length > 1 || selectedAction) {
        setSelectedIds([]);
        handleClassificationClose();
      } else {
        setSelectedIds((prev) => prev.filter((id) => !variables.configured_discount_ids.includes(id)));
      }
    }
  });

  const updateConfiguredDiscountStatus = async () => {
    const selectedFilters = appliedFilters

    setStatusLoading(true)
    if(selectedIds.length === 0) {
      showNotification('Select at least one configured discount', 'error')
      handleClassificationClose()
      setStatusLoading(false)
      return
    }

    if(selectedFilters?.restaurant_ids.length === 0 && !selectedFilters?.restaurant_group_id) {
      showNotification('Select at least one restaurant group or restaurant', 'error')
      handleClassificationClose()
      setStatusLoading(false)
      return
    }

    if(!selectedAction) {
      showNotification('Select at least one status', 'error')
      handleClassificationClose()
      setStatusLoading(false)
      return
    }

    try {
      await bulkStatusUpdateMutation({
        restaurant_group_id: selectedFilters?.restaurant_group_id,
        restaurant_ids: selectedFilters?.restaurant_ids,
        configured_discount_ids: selectedIds,
        status: selectedAction,
      });
    } finally {
      setStatusLoading(false);
      handleClassificationClose();
    }
  }

  const updateSingleConfiguredDiscountStatus = async (record, nextStatus) => {
    if (!record?.id || !record?.restaurant?.id || record?.status === nextStatus) return

    // Close before awaiting: the table unmounts while refetching, which detaches
    // the popover anchor and makes MUI fall back to positioning it at (0, 0).
    handleStatusMenuClose()
    setRowStatusLoadingId(record.id)

    try {
      await bulkStatusUpdateMutation({
        restaurant_ids: [record.restaurant.id],
        configured_discount_ids: [record.id],
        status: nextStatus,
      });
    } finally {
      setRowStatusLoadingId(null)
    }
  }

  const columnOptions = [
    { key: "name", sortable: true },
    { key: "type", sortable: true },
    { key: "discount_guid", label: "Perq Guid", sortable: true },
    { key: "applies_to", sortable: true },
    { key: "value", sortable: true },
    { key: "owner", sortable: true },
    { key: "classification", sortable: true },
    { key: "active", sortable: true },
    { key: "created_at", sortable: true },
    { key: "updated_at", sortable: true },
    { key: "updated_by", sortable: true },
  ];

  const columns = columnOptions?.map((column) => {
    return {
      key: column.key,
      label: column.label || camelize(column.key),
      sortable: column.sortable,
    };
  });

  const TableRows = (data) => {
    return data?.map((record) => {
      const rowLevelUpdatePermission = strictCanScope(ability, 'update', 'Restaurant', `${record?.restaurant?.id}`)

      return {
        id: record?.id,
        name: record?.name,
        type: record?.discount_type,
        discount_guid: record?.guid,
        applies_to: record?.selection_type,
        value: getAmount(record?.amount, record?.discount_type),
        owner: record?.restaurant?.name,
        classification: {
          display: (
            <StyledStatusButton
              disableRipple
              endIcon={!rowLevelUpdatePermission ? null : <KeyboardArrowDownIcon sx={{color: 'grey'}}/>}
              onClick={(event) => handleStatusMenuOpen(event, record)}
              disabled={!rowLevelUpdatePermission || rowStatusLoadingId === record?.id}
            >
              <StatusContainer action={record?.status}>
                {capitalize(record?.status)}
              </StatusContainer>
            </StyledStatusButton>
          ),
          sortValue: record?.status
        },
        active: {
          display: (
            <Switch checked={record?.active} />
          ),
          sortValue: record?.active
        },
        created_at: formatDate(record?.created_at, record?.time_zone_abbr),
        updated_at: formatDate(record?.updated_at, record?.time_zone_abbr),
        updated_by: getAdminName(record?.admin)
      }
    })
  }

  const rows = TableRows(configuredDiscounts?.data);
  const statusMenuOpen = Boolean(statusMenuAnchorEl)
  const hasSearchTerm = Boolean(debouncedSearchTerm)
  const searchDisabled = !hasAppliedSelection || !configuredDiscounts?.data
  // Keep the table mounted while searching so the search bar does not lose focus.
  const showLoader = isFetching && hasAppliedSelection && (!hasSearchTerm || !configuredDiscounts?.data)

  const handleServerSort = (columnKey, direction) => {
    setSortBy(columnKey)
    setSortOrder(direction)
    setPage(1)
  }

  const handleSearch = (searchQuery) => {
    if (searchDisabled) return

    setSearch(searchQuery)
    setPage(1)
    setSelectedIds([])
  }

  return (
    <ConfiguredDiscountPage>
      {/* Bread crumbs */}
      <StyledBreadCrumbContainer>
        <Breadcrumbs>
          <NavigableBreadcrumbLink LinkComponent={StyledLink} label="Home" to="/admin/dashboard" />
          <StyledLink color={"#515152"}>Configured Perqs</StyledLink>
        </Breadcrumbs>
      </StyledBreadCrumbContainer>

      {/* Filters */}
      <FilterContainer>
        <Box sx={filterContinerStyle}>
          <Box sx={filterSectionStyle}>
            <Typography
              variant="body2"
              sx={typographyStyle}
            >
              View
            </Typography>

            {/* Restaurant group filter */}
            <StyledFormControl size="small">
              <StyledInputLabel>Restaurant Group</StyledInputLabel>
               <Select
                data-testid='restaurant-group-filter'
                size="small"
                label="Restaurant Group"
                  MenuProps={{
                    ...menuPropStyle,
                    PaperProps: {
                      ...menuPropStyle.PaperProps,
                      ref: restaurantGroupMenuRef,
                    },
                  }}
                sx={{
                  ...selectBaseStyles,
                  minWidth: { xs: "100%", sm: "160px" },
                  width: { xs: "100%", sm: "160px" },
                  borderColor: "#2b4fb9",
                }}
                onChange={handleRestaurantGroupChange}
                onClose={() => setTimeout(() => setRestaurantGroupSearch(''), 1000)}
                value={filters?.restaurant_group_id || ""}
                renderValue={() => getRestaurantGroupName(filters?.restaurant_group_id)}
                endAdornment={
                  filters?.restaurant_group_id ? (
                    <StyledFilterCancel position="end">
                      <IconButton
                        edge='end'
                        size="small"
                        disableRipple
                        onClick={handleRestaurantGroupClear}
                      >
                        <ClearIcon sx={{ fontSize: '20px' }} />
                      </IconButton>
                    </StyledFilterCancel>
                  ) : null
                }
              >
                <DropdownSearchBar changeSearchText={setRestaurantGroupSearch} placeholder={'Search restaurant group'} isFetching={restaurantGroupFetching} />
                {restaurantGroups.map((res) => (
                  <StyledMenuItem
                    key={res?.label}
                    value={res?.label}
                  >
                    {
                      filters?.restaurant_group_id === res?.label ? <SelectedMenuItem data={res?.value} /> : res?.value
                    }
                  </StyledMenuItem>
                ))}
                <DropdownInfiniteLoader
                  hasNextPage={hasNextRestaurantGroupsPage}
                  targetRef={restaurantGroupLoaderRef}
                />
              </Select>
            </StyledFormControl>

            {/* Restaurant filter */}
            <StyledFormControl size="small">
               <StyledInputLabel>Restaurant</StyledInputLabel>
               <Select
                data-testid='restaurant-filter'
                size="small"
                label="Restaurant"
                MenuProps={{
                  ...menuPropStyle,
                  PaperProps: {
                    ...menuPropStyle.PaperProps,
                    ref: restaurantMenuRef,
                  },
                }}
                sx={{
                  ...selectBaseStyles,
                  minWidth: { xs: "100%", sm: "160px" },
                  width: { xs: "100%", sm: "160px" },
                  borderColor: "#2b4fb9",
                }}
                onChange={handleRestaurantChange}
                onClose={() => setTimeout(() => setRestaurantSearch(''), 1000)}
                value={filters?.restaurant_ids || []}
                displayEmpty={Boolean(prefillRestaurantName)}
                multiple
                renderValue={() => getRestaurantDisplayValue()}
                endAdornment={
                  filters?.restaurant_ids?.length > 0 || prefillRestaurantName ? (
                    <StyledFilterCancel position="end">
                      <IconButton
                        edge='end'
                        size="small"
                        disableRipple
                        onClick={handleRestaurantClear}
                      >
                        <ClearIcon sx={{fontSize: '20px'}}/>
                      </IconButton>
                    </StyledFilterCancel>
                  ) : null
                }
              >
                <DropdownSearchBar changeSearchText={setRestaurantSearch} placeholder={'Search restaurant'} isFetching={restaurantFetching} />
                {restaurants.map((res) => (
                  <StyledMenuItem
                    key={res?.id}
                    value={res?.id}
                  >
                    {
                      filters?.restaurant_ids?.includes(res?.id) ? <SelectedMenuItem data={res?.name} /> : res?.name
                    }
                  </StyledMenuItem>
                ))}
                <DropdownInfiniteLoader
                  hasNextPage={hasNextRestaurantsPage}
                  targetRef={restaurantLoaderRef}
                />
              </Select>
            </StyledFormControl>

            {/* Status filter */}
            <StyledFormControl size="small">
              <StyledInputLabel>Status</StyledInputLabel>
              <Select
                data-testid='status-filter'
                size="small"
                label="Status"
                MenuProps={statusMenuPropStyle}
                sx={{
                  ...selectBaseStyles,
                  minWidth: { xs: "100%", sm: "160px" },
                  width: { xs: "100%", sm: "160px" },
                  borderColor: "#2b4fb9",
                }}
                onChange={handleStatusChange}
                value={filters?.status || ""}
                renderValue={() => startCase(filters?.status)}
                endAdornment={
                  filters?.status? (
                    <StyledFilterCancel position="end">
                      <IconButton
                        edge='end'
                        size="small"
                        disableRipple
                        onClick={handleStatusClear}
                      >
                        <ClearIcon sx={{fontSize: '20px'}}/>
                      </IconButton>
                    </StyledFilterCancel>
                  ) : null
                }
              >
                {
                  STATUS.map((stat) => (
                    <StyledMenuItem
                      key={stat?.value}
                      value={stat?.value}
                    >
                      {
                        filters?.status === stat?.value ? <SelectedMenuItem data={stat?.label} /> : stat?.label
                      }
                    </StyledMenuItem>
                  ))
                }
              </Select>
            </StyledFormControl>
          </Box>

          <Box
            sx={actionSectionStyle}
          >

            <ResetButton
              onClick={handleReset}
              status={isFetching}
              disabled={statusLoading}
            />

            <UpdateButton
              onClick={handleChange}
              filtersChanged={filtersChanged}
              status={isFetching}
            />
          </Box>
        </Box>
      </FilterContainer>

      <MenuHeading
        report={false}
        dataTestId={'page-title'}
        rightComponent={
          <StyledSearchBar
            value={search}
            placeholder="Search"
            disabled={searchDisabled}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={(e) => handleSearch(e.target.value)}
            autoComplete="off"
            inputProps={{ 'data-testid': 'configured-discounts-search-input' }}
          />
        }
      >
        Configured Perqs
      </MenuHeading>
      <FetchButtonContainer>
        <ClassificationActionButton
          data-testid='classification-action-btn'
          variant="contained"
          onClick={handleClassificationOpen}
          disabled={!hasAppliedSelection || !appliedStatusUpdatePermission || statusLoading}
        >
          Classification Actions
        </ClassificationActionButton>

        <Button
          data-testid="fetch-configured-discount-btn"
          sx={{ background: "#2b4fb9" }}
          variant="contained"
          onClick={fetchDiscountsFromToast}
          component="label"
          disabled={!fetchPermission || isLoading}
        >
          {isLoading ? <LoadingSpinner isLoading={true} /> : <CachedIcon />}
        </Button>
      </FetchButtonContainer>

      {/* Index table */}
      {showLoader ? (
          <Loader />
        ) : (hasAppliedSelection && configuredDiscounts?.data) ? (
          <IndexTable
            columns={columns}
            data={rows}
            tableId="configured-discounts"
            type="entries"
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            page={page}
            setPage={setPage}
            pageCount={configuredDiscounts?.pageCount}
            checkboxes={true}
            selectedIds={selectedIds}
            setSelectedIds={setSelectedIds}
            report={false}
            showDownloadButton={true}
            disableDownloadButton={configuredDiscounts?.data?.length === 0 || csvLoading}
            handleExportCsv={handleExportCsv}
            csvLoading={csvLoading}
            serverSort={true}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSort={handleServerSort}
            searchLoading={isFetching}
            hasSearchTerm={hasSearchTerm}
            emptyStateText={hasSearchTerm ? "No configured perqs match your search" : "No Data Exists"}
          />
        ) : (
          <div>
            <Alert
              data-testid='alert-message'
              severity="info"
            >
              Select a restaurant group or restaurant
            </Alert>
          </div>
        )}

      <Popover
        open={statusMenuOpen}
        anchorEl={statusMenuAnchorEl}
        onClose={handleStatusMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: statusPopoverPaperStyle }}
        data-testid="status-menu-popover"
      >
        <StatusMenuList dense disablePadding>
          {rowStatusOptions.map((action) => {
            const isCurrentStatus = selectedRecord?.status === action.value

            return (
              <StyledMenuItem
                key={action.value}
                disabled={isCurrentStatus || rowStatusLoadingId === selectedRecord?.id}
                onClick={() => updateSingleConfiguredDiscountStatus(selectedRecord, action.value)}
                sx={statusMenuItemStyle}
              >
                {action.label}
              </StyledMenuItem>
            )
          })}
        </StatusMenuList>
      </Popover>

    {/* Classification Modal */}
    <DiscountClassificationModal
      open={open}
      handleClose={handleClassificationClose}
      selectedAction={selectedAction}
      setSelectedAction={setSelectedAction}
      onUpdate={updateConfiguredDiscountStatus}
      statusLoading={statusLoading}
      actions={actions}
    />
    </ConfiguredDiscountPage>
  )
}
